import { render, staticRenderFns } from "./SessionListCards.vue?vue&type=template&id=2c63f79c&scoped=true"
import script from "./SessionListCards.vue?vue&type=script&lang=ts"
export * from "./SessionListCards.vue?vue&type=script&lang=ts"
import style0 from "./SessionListCards.vue?vue&type=style&index=0&id=2c63f79c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c63f79c",
  null
  
)

export default component.exports